import React from 'react';
import { Link } from 'react-router-dom';

function MyServicesection() {
  return (
    <div>
      <div className="service10 sp2">
    <div className="container">
    <div className="row align-items-center space-margin60">
      <div className="col-lg-4">
        <div className="heading10">
          <h5 className="vl-section-subtitle aos-init"  data-aos-duration="900"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M9.45001 17.8772C14.2115 17.6442 18 13.7338 18 8.94408C18 7.4743 17.6433 6.08732 17.0111 4.86399C14.4764 6.3183 13.2091 7.04546 12.2507 8.02546C11.1061 9.19582 10.2724 10.6308 9.82481 12.201C9.45001 13.5159 9.45001 14.9697 9.45001 17.8772Z" fill="#02111A"></path>
            <path d="M8.55001 17.8772C3.78851 17.6442 0 13.7338 0 8.94408C0 7.47429 0.356744 6.08731 0.988876 4.86398C3.52358 6.3183 4.79093 7.04546 5.74937 8.02547C6.89397 9.19583 7.72761 10.6308 8.17521 12.2011C8.55001 13.5159 8.55001 14.9697 8.55001 17.8772Z" fill="#02111A"></path>
            <path d="M1.43959 4.08981C3.97405 5.54399 5.24127 6.27107 6.57492 6.60594C8.16664 7.00559 9.83338 7.00559 11.4251 6.60594C12.7587 6.27108 14.026 5.54399 16.5604 4.08982C14.9571 1.62862 12.1699 0 9 0C5.8301 0 3.04295 1.62862 1.43959 4.08981Z" fill="#02111A"></path>
            </svg> OUR SERVICES</h5>
            <div className="space16"></div>
            <h2 className="vl-section-title aos-init"  data-aos-duration="1000">Our Clients Services</h2>
        </div>
      </div>
      <div className="col-lg-5"></div>
      <div className="col-lg-3">
        
      </div>
    </div>

        <div className="row">
            <div className="col-lg-4 col-md-6 aos-init"  data-aos-duration="800">
                <div className="service10-boxarea">
                    <Link to="/Employee_training" className="title">Employee Training</Link>
                    <div className="space32"></div>
                    <div className="img1">
                        <img src="assets/img/all-images/service/employee_training.png" title='Employee performance management programs
' alt="Employee Training"/>
                    </div>
                    <div className="space20"></div>
                    <div className="content-area">
                        <p>Enhance workforce productivity with customized employee training programs designed to upskill corporate teams and boost performance.</p>
                        <div className="arrow">
                            <Link to="/Employee_training"><i className="fa-solid fa-arrow-right"></i></Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-lg-4 col-md-6 aos-init"  data-aos-duration="900">
                <div className="service10-boxarea">
                    <Link to="/Manpower_Sourcing" className="title" title='Manpower Sourcing' >Manpower Sourcing </Link>
                    <div className="space32"></div>
                    <div className="img1">
                        <img src="assets/img/all-images/service/manpower_Sourcing.png" alt="Manpower Sourcing"/>
                    </div>
                    <div className="space20"></div>
                    <div className="content-area">
                        <p>Hire the right talent faster with our expert corporate manpower sourcing solutions tailored to your business needs.</p>
                        <div className="arrow">
                            <Link to="/Manpower_Sourcing"><i className="fa-solid fa-arrow-right"></i></Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-lg-4 col-md-6 aos-init"  data-aos-duration="1000">
                <div className="service10-boxarea">
                    <Link to="/Corporate_Grooming_Programs" className="title" title='Corporate Grooming Programs'>Corporate Grooming Programs </Link>
                    <div className="space32"></div>
                    <div className="img1">
                        <img src="assets/img/all-images/service/corporate_grooming_programs.png" alt="Corporate Grooming Programs"/>
                    </div>
                    <div className="space20"></div>
                    <div className="content-area">
                        <p>Professional grooming services to refine employee behaviour, communication, and workplace etiquette for stronger brand representation.</p>
                        <div className="arrow">
                            <Link to="/Corporate_Grooming_Programs" title='Corporate Grooming Programs'><i className="fa-solid fa-arrow-right"></i></Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-lg-4 col-md-6 aos-init"  data-aos-duration="1100">
                <div className="service10-boxarea">
                    <Link to="/Performance_Management" className="title">Performance Management </Link>
                    <div className="space32"></div>
                    <div className="img1">
                        <img src="assets/img/all-images/service/performance_management.png" alt="Performance Management "/>
                    </div>
                    <div className="space20"></div>
                    <div className="content-area">
                        <p>Implement structured performance management systems that align employee output with business objectives and measurable outcomes.</p>
                        <div className="arrow">
                            <Link to="/Performance_Management"><i className="fa-solid fa-arrow-right"></i></Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-lg-4 col-md-6 aos-init"  data-aos-duration="1200">
                <div className="service10-boxarea">
                    <Link to="/KRAs_KPIs" className="title">KRAs & KPIs </Link>
                    <div className="space32"></div>
                    <div className="img1">
                        <img src="assets/img/all-images/service/kra's_&_kpi's.png" alt="KRAs & KPIs"/>
                    </div>
                    <div className="space20"></div>
                    <div className="content-area">
                        <p>Define clear Key Result Areas (KRAs) and Key Performance Indicators (KPIs) to drive accountability, goal tracking, and employee growth.</p>
                        <div className="arrow">
                            <Link to="/KRAs_KPIs"><i className="fa-solid fa-arrow-right"></i></Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-lg-4 col-md-6 aos-init"  data-aos-duration="1300">
                <div className="service10-boxarea">
                    <Link to="/Company_Policy_Development" className="title">Company Policy Development </Link>
                    <div className="space32"></div>
                    <div className="img1">
                        <img src="assets/img/all-images/service/company_policy_development.png" alt=""/>
                    </div>
                    <div className="space20"></div>
                    <div className="content-area">
                        <p>Build a compliant and efficient work culture with professionally drafted company policies customized to your industry and operations.</p>
                        <div className="arrow">
                            <Link to="/Company_Policy_Development"><i className="fa-solid fa-arrow-right"></i></Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
    </div>
  )
}

export default MyServicesection
